var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.144043,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M12 17.1439C12.2833 17.1439 12.5208 17.0481 12.7125 16.8564C12.9041 16.6648 13 16.4273 13 16.1439V12.1439C13 11.8606 12.9041 11.6231 12.7125 11.4314C12.5208 11.2398 12.2833 11.1439 12 11.1439C11.7166 11.1439 11.4791 11.2398 11.2875 11.4314C11.0958 11.6231 11 11.8606 11 12.1439V16.1439C11 16.4273 11.0958 16.6648 11.2875 16.8564C11.4791 17.0481 11.7166 17.1439 12 17.1439ZM12 9.14392C12.2833 9.14392 12.5208 9.04809 12.7125 8.85642C12.9041 8.66475 13 8.42725 13 8.14392C13 7.86059 12.9041 7.62309 12.7125 7.43142C12.5208 7.23975 12.2833 7.14392 12 7.14392C11.7166 7.14392 11.4791 7.23975 11.2875 7.43142C11.0958 7.62309 11 7.86059 11 8.14392C11 8.42725 11.0958 8.66475 11.2875 8.85642C11.4791 9.04809 11.7166 9.14392 12 9.14392ZM12 22.1439C10.6166 22.1439 9.31662 21.8814 8.09995 21.3564C6.88329 20.8314 5.82495 20.1189 4.92495 19.2189C4.02495 18.3189 3.31245 17.2606 2.78745 16.0439C2.26245 14.8273 1.99995 13.5273 1.99995 12.1439C1.99995 10.7606 2.26245 9.46059 2.78745 8.24392C3.31245 7.02725 4.02495 5.96892 4.92495 5.06892C5.82495 4.16892 6.88329 3.45642 8.09995 2.93142C9.31662 2.40642 10.6166 2.14392 12 2.14392C13.3833 2.14392 14.6833 2.40642 15.9 2.93142C17.1166 3.45642 18.175 4.16892 19.075 5.06892C19.975 5.96892 20.6875 7.02725 21.2125 8.24392C21.7375 9.46059 22 10.7606 22 12.1439C22 13.5273 21.7375 14.8273 21.2125 16.0439C20.6875 17.2606 19.975 18.3189 19.075 19.2189C18.175 20.1189 17.1166 20.8314 15.9 21.3564C14.6833 21.8814 13.3833 22.1439 12 22.1439ZM12 20.1439C14.2333 20.1439 16.125 19.3689 17.675 17.8189C19.225 16.2689 20 14.3773 20 12.1439C20 9.91059 19.225 8.01892 17.675 6.46892C16.125 4.91892 14.2333 4.14392 12 4.14392C9.76662 4.14392 7.87495 4.91892 6.32495 6.46892C4.77495 8.01892 3.99995 9.91059 3.99995 12.1439C3.99995 14.3773 4.77495 16.2689 6.32495 17.8189C7.87495 19.3689 9.76662 20.1439 12 20.1439Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.04fe67b2394010c4a461847c630ce845.svg";
export { ForwardRef as ReactComponent };